import {
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";

import { useAuth } from "../context/AuthContext";

import "./WebAppLayout.css";

const navigation = [
  ["/app/today", "Today", "◷"],
  ["/app/routines", "Routines", "↻"],
  ["/app/countdowns", "Countdowns", "⌛"],
  ["/app/calendar", "Calendar", "□"],
  ["/app/event-circle", "Event Circle", "◎"],
  ["/app/profile", "Profile", "○"],
  ["/app/settings", "Settings", "⚙"],
] as const;

export function WebAppLayout() {
  const {
    user,
    logout,
  } = useAuth();

  const navigate = useNavigate();

  async function signOut() {
    await logout();

    navigate("/", {
      replace: true,
    });
  }

  return (
    <div className="webapp-shell">
      <aside className="webapp-sidebar">
        <NavLink
          to="/app/today"
          className="webapp-brand"
        >
          <img
            src="/favicon-48.png"
            width="38"
            height="38"
            alt=""
          />

          <span>
            SARADIUM
            <small>Web app</small>
          </span>
        </NavLink>

        <nav aria-label="SARADI application">
          {navigation.map(([to, label, icon]) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                isActive ? "active" : ""
              }
            >
              <span aria-hidden="true">{icon}</span>
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="webapp-account">
          <strong>{user?.name || "SARADI user"}</strong>

          <span>{user?.email}</span>

          <button
            type="button"
            onClick={signOut}
          >
            Sign out
          </button>
        </div>
      </aside>

      <main className="webapp-main">
        <Outlet />
      </main>

      <nav
        className="webapp-mobile-nav"
        aria-label="Mobile application navigation"
      >
        {navigation.map(([to, label, icon]) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              isActive ? "active" : ""
            }
          >
            <span aria-hidden="true">{icon}</span>

            <small>
              {label === "Event Circle"
                ? "Circle"
                : label}
            </small>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}